<span
  [innerHTML]="sanitizedIcon"
  [ngStyle]="{ height: size + 'px', width: size + 'px' }"
  class="custom-icon-container"
></span>
